// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3dih9","toggle":"styles_toggle__1C0Cv","preview":"styles_preview__275x6"};